export class CartItem {
    brand_name: string;
    label: string;
    description: string;
    brand_id: number;
    ids: any;
    is_subscription_item: number;
    is_customizable: boolean;
    is_veg: number;
    id: string;
    quantity: number;
    remark: string;
    price: number;
    marked_price: number;

    constructor(
        id: string = '',
        quantity: number = 0,
        remark: string = '',
        details: any = {}
    ) {
        this.id = id;
        this.quantity = quantity || 1;
        this.remark = remark || '';
        Object.assign(this, details);
    }

    static build(data) {
        return new CartItem(data.id, data.quantity, data.remark);
    }
}
